define("shared/components/shared/trial-countdown", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! Trial Plan Counter }}
  {{#if this.hasActiveTrial}}
    <div class="cTC--wrapper u--hide--mobile" data-test-id="trial-countdown">
      <LinkTo @route={{if @route @route "account.overview"}} class="cTC--container">
        {{! Button Bg }}
        <svg class="cTC--button" height="38" viewBox="0 0 167 38" width="167" xmlns="http://www.w3.org/2000/svg">
          <rect
            fill="#E6F9F3"
            fill-rule="evenodd"
            height="36"
            rx="18"
            stroke-width="1"
            transform="translate(1 1)"
            width="165"
            x="0"
            y="0"
          ></rect>
        </svg>
        {{! Day Count }}
        <div class="cTC--count">
          <span class="cTC--count__item" data-test-id="days-remaining">{{this.trialDaysRemaining}}</span>
        </div>
        {{! Title }}
        <span class="cTC--text" data-test-id="text">
          {{t "app.trial_plan_counter.title" count=this.trialDaysRemaining}}
        </span>
        {{! Emoji }}
        {{#if (gt this.trialDaysRemaining 5)}}
          <span class="cTC--status" data-test-id="active">
            {{t "app.trial_plan_counter.emoji_active"}}
          </span>
        {{else if (gt this.trialDaysRemaining 1)}}
          <span class="cTC--status" data-test-id="warning">
            {{t "app.trial_plan_counter.emoji_warning"}}
          </span>
        {{else}}
          <span class="cTC--status" data-test-id="alert">
            {{t "app.trial_plan_counter.emoji_alert"}}
          </span>
        {{/if}}
      </LinkTo>
    </div>
  {{/if}}
  */
  {
    "id": "7QHWv8wx",
    "block": "[[[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"  \"],[10,0],[14,0,\"cTC--wrapper u--hide--mobile\"],[14,\"data-test-id\",\"trial-countdown\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"cTC--container\"]],[[\"@route\"],[[52,[30,1],[30,1],\"account.overview\"]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[10,\"svg\"],[14,0,\"cTC--button\"],[14,\"height\",\"38\"],[14,\"viewBox\",\"0 0 167 38\"],[14,\"width\",\"167\"],[14,\"xmlns\",\"http://www.w3.org/2000/svg\",\"http://www.w3.org/2000/xmlns/\"],[12],[1,\"\\n        \"],[10,\"rect\"],[14,\"fill\",\"#E6F9F3\"],[14,\"fill-rule\",\"evenodd\"],[14,\"height\",\"36\"],[14,\"rx\",\"18\"],[14,\"stroke-width\",\"1\"],[14,\"transform\",\"translate(1 1)\"],[14,\"width\",\"165\"],[14,\"x\",\"0\"],[14,\"y\",\"0\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cTC--count\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"cTC--count__item\"],[14,\"data-test-id\",\"days-remaining\"],[12],[1,[30,0,[\"trialDaysRemaining\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,1],[14,0,\"cTC--text\"],[14,\"data-test-id\",\"text\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"app.trial_plan_counter.title\"],[[\"count\"],[[30,0,[\"trialDaysRemaining\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"trialDaysRemaining\"]],5],null],[[[1,\"        \"],[10,1],[14,0,\"cTC--status\"],[14,\"data-test-id\",\"active\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"app.trial_plan_counter.emoji_active\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,0,[\"trialDaysRemaining\"]],1],null],[[[1,\"        \"],[10,1],[14,0,\"cTC--status\"],[14,\"data-test-id\",\"warning\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"app.trial_plan_counter.emoji_warning\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"cTC--status\"],[14,\"data-test-id\",\"alert\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"app.trial_plan_counter.emoji_alert\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@route\"],false,[\"if\",\"link-to\",\"t\",\"gt\"]]",
    "moduleName": "shared/components/shared/trial-countdown.hbs",
    "isStrictMode": false
  });
  let TrialCountdownComponent = _exports.default = (_class = class TrialCountdownComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
    }
    get hasActiveTrial() {
      return this.auth.currentAccount.hasActiveTrial;
    }
    get trialDaysRemaining() {
      return this.auth.currentAccount.trialDaysRemaining;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrialCountdownComponent);
});